module.exports = __webpack_public_path__ + "media/images/new-ui-images/dot-list-icon-059487bfc4921b4d8bd21fb41a3c2520.svg";